import queryString from "query-string";

import {
  SIDELOADED_BUSINESS,
  SIDELOADED_BUSINESS_SET,
} from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import { serializeSideLoadedBusiness } from "lib/serializers/sideLoadedBusinesses";
import { serializeSideLoadedDataSet } from "lib/serializers/sideLoadedDataSets";
import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const sideLoadedDataUrlCreator = ({
  changesSince,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/sideloaded-data/", id, action),
    query: {
      changesSince,
    },
  });

export const SideLoadedBusinessAction = offlineActionCreator(
  SIDELOADED_BUSINESS,
  serializeSideLoadedBusiness,
  sideLoadedDataUrlCreator,
  false,
);

const sideLoadedDataSetUrlCreator = ({
  changesSince,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/sideloaded-data-sets/", id, action),
    query: {
      changesSince,
    },
  });

// Creating is not included - a data set is created by uploading a CSV, which
// needs a multipart request. See sagas/sideLoadedDataSets.
export const SideLoadedDataSetAction = offlineActionCreator(
  SIDELOADED_BUSINESS_SET,
  serializeSideLoadedDataSet,
  sideLoadedDataSetUrlCreator,
  false,
);

export const uploadSideLoadedDataSet = (name: string, file: File) => ({
  type: SIDELOADED_BUSINESS_SET.UPLOAD.REQUEST,
  name,
  meta: { file },
});

export const uploadSideLoadedDataSetSuccess = () => ({
  type: SIDELOADED_BUSINESS_SET.UPLOAD.SUCCESS,
});

export const uploadSideLoadedDataSetFailure = (errorMessage: string) => ({
  type: SIDELOADED_BUSINESS_SET.UPLOAD.FAILURE,
  errorMessage,
  error: true,
});

// The error outlives the modal it is shown in, so reopening would otherwise
// present the last failure as though it had just happened.
export const resetSideLoadedDataSetUploadError = () => ({
  type: SIDELOADED_BUSINESS_SET.UPLOAD.RESET_ERROR,
});

// One pusher event covers both records and data sets, but the socket saga
// dispatches a single action per event - so fan out from here.
export const refreshSideLoadedData = () => ({
  type: SIDELOADED_BUSINESS_SET.REFRESH.FROM_SOCKET,
});
